const Switch = {
  baseStyle: {
    track: {
      bg: 'red.600',
      _checked: {
        bg: 'brand',
      },
    },
  },
};
export default Switch;
